
export default function BoltGen({data}) {
  return (
    <>
      <section className="lyft-minimum-area bolt-gen-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="lyft-minimum-head">
                <h3 className="heading center-heading">{data && data.titlePart1} <span className="gradiant-color">{data && data.titlePart2}</span> {data && data.titlePart3}</h3>
                <p className="sub-heading">{data && data.description}</p>
              </div>
            </div>

            {data && data.boxes && data.boxes.map((box, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div className="lyft-minimum-box">
                  <span>
                    <span>
                      <img loading="lazy" src={box.image} alt="Icon" />
                    </span>
                  </span>
                  <small>{box.title}</small>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
